var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: " Icons / synchronize / 16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 8C14.9923 9.45336 14.5323 10.8683 13.684 12.0484C12.8358 13.2285 11.6412 14.1154 10.266 14.5858C8.89091 15.0563 7.40344 15.0871 6.01003 14.6739C4.61662 14.2607 3.38638 13.424 2.49 12.28V15H1V10H6V11.5H3.76C4.27573 12.1252 4.92325 12.6286 5.65624 12.9744C6.38922 13.3201 7.18956 13.4996 8 13.5C9.45788 13.4974 10.8553 12.917 11.8862 11.8862C12.917 10.8553 13.4974 9.45788 13.5 8H15ZM15 1V6H10V4.51H12.24C11.5223 3.63224 10.5503 2.99824 9.45774 2.6951C8.36516 2.39196 7.20552 2.43455 6.13812 2.81702C5.07071 3.19949 4.14792 3.90307 3.49649 4.83112C2.84506 5.75917 2.49696 6.86615 2.5 8H1C1.00774 6.54664 1.46766 5.13173 2.31595 3.95159C3.16424 2.77146 4.35884 1.88463 5.73396 1.41416C7.10909 0.943696 8.59656 0.912922 9.98997 1.32611C11.3834 1.7393 12.6136 2.57596 13.51 3.72V1H15Z",
    fill: "#1F1F1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.4125044ab85cb69c648da3bed68cacb4.svg";
export { ForwardRef as ReactComponent };